import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';

// Admin API calls
export const getCollegeLeads = async (status = null, limit = 100) => {
  try {
    let url = `${API_URL}/colleges/leads?limit=${limit}`;
    if (status) url += `&status=${status}`;
    const response = await axios.get(url);
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: 'Failed to fetch college leads' };
  }
};

export const getMentorApplications = async (status = null, limit = 100) => {
  try {
    let url = `${API_URL}/mentors/applications?limit=${limit}`;
    if (status) url += `&status=${status}`;
    const response = await axios.get(url);
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: 'Failed to fetch mentor applications' };
  }
};

export const getContactInquiries = async (status = null, limit = 100) => {
  try {
    let url = `${API_URL}/contact/inquiries?limit=${limit}`;
    if (status) url += `&status=${status}`;
    const response = await axios.get(url);
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: 'Failed to fetch contact inquiries' };
  }
};

export const getDownloadStats = async () => {
  try {
    const response = await axios.get(`${API_URL}/downloads/stats`);
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: 'Failed to fetch download stats' };
  }
};

// Export to CSV utility
export const exportToCSV = (data, filename) => {
  if (!data || data.length === 0) {
    alert('No data to export');
    return;
  }

  // Get headers from first object
  const headers = Object.keys(data[0]);
  
  // Create CSV content
  let csv = headers.join(',') + '\n';
  
  data.forEach(row => {
    const values = headers.map(header => {
      const value = row[header];
      // Handle arrays and objects
      if (Array.isArray(value)) {
        return `"${value.join('; ')}"`;
      }
      if (typeof value === 'object' && value !== null) {
        return `"${JSON.stringify(value)}"`;
      }
      // Escape quotes and wrap in quotes if contains comma
      const stringValue = String(value || '');
      if (stringValue.includes(',') || stringValue.includes('"')) {
        return `"${stringValue.replace(/"/g, '""')}"`;
      }
      return stringValue;
    });
    csv += values.join(',') + '\n';
  });

  // Create blob and download
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  link.setAttribute('href', url);
  link.setAttribute('download', filename);
  link.style.visibility = 'hidden';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
